export const FIXED = 'fixed';
export const FLUID = 'fluid';
